"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlansBank = void 0;
const AbstractBatcherBank_1 = require("./base/AbstractBatcherBank");
const _ = require("lodash");
const PlanModel_1 = require("../models/PlanModel");
class PlansBank extends AbstractBatcherBank_1.AbstractBatcherBank {
    constructor(options) {
        super(options);
    }
    generate(data) {
        return new PlanModel_1.PlanModel({
            banks: this.options.banks(),
            clients: this.options.clients,
            model: data
        });
    }
    async fetchCollection(event) {
        const client = this.options.clients.provisionChargingStationClient();
        const plans = await Promise.all(_.chain(event.items)
            .groupBy((i) => i.org_id)
            .map(async (items, org_id) => {
            const plans = await client.getPlans({ org_id });
            return items.map((i) => {
                return plans.find((plan) => plan.id === i.id);
            });
        })
            .flatMap()
            .value());
        event.apply(plans.reduce((prev, cur) => {
            prev[this.generateID(cur)] = cur;
            return prev;
        }, {}));
    }
    generateIDFromData(data) {
        return this.generateID(data);
    }
    generateID(id) {
        return `${id.org_id}:${id.id}`;
    }
    patch(event) {
        event.object.options.model = event.data;
    }
}
exports.PlansBank = PlansBank;
